import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "hidden lg:border-t lg:border-b lg:border-clay-200 sm:block" }
const _hoisted_2 = { "aria-label": "Progress" }
const _hoisted_3 = {
  class: "border divide-y rounded-md divide-clay-300 border-clay-500 md:flex md:divide-y-0",
  role: "list"
}
const _hoisted_4 = { class: "relative md:flex md:flex-1" }
const _hoisted_5 = ["title", "onClick"]
const _hoisted_6 = { class: "ml-4 text-sm font-medium text-clay-900" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "flex items-center justify-center w-10 h-10 border-2 rounded-full shrink-0 bg-electric-600 border-electric-600" }
const _hoisted_9 = { class: "text-white" }
const _hoisted_10 = { class: "ml-4 text-sm font-medium text-electric-600" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "flex items-center justify-center w-10 h-10 border-2 rounded-full shrink-0 border-clay-500" }
const _hoisted_13 = { class: "text-clay-500 group-hover:text-clay-900" }
const _hoisted_14 = { class: "ml-4 text-sm font-medium text-clay-500 group-hover:text-clay-900" }
const _hoisted_15 = { class: "min-h-screen sm:pt-12 bg-clay-50" }
const _hoisted_16 = { class: "flex flex-col justify-center min-h-full px-4 py-0 py-4 sm:py-12 sm:px-6 lg:px-8" }
const _hoisted_17 = { class: "sm:mx-auto sm:w-full sm:max-w-5xl" }

import {Ref, ref} from "vue";
// @ts-ignore
import {ResponseStatus} from "@servicestack/client";
import OnboardingStepHeadshot from "@/../Features/Onboarding/OnboardingStepHeadshot.vue";
import OnboardingStepRegion from "@/../Features/Onboarding/OnboardingStepRegion.vue";
import OnboardingStepManagingAccountFor from "./OnboardingStepManagingAccountFor.vue";
import OnboardingStepGoals from "./OnboardingStepGoals.vue";
import OnboardingStepUpgradeToPro from "./OnboardingStepUpgradeToPro.vue";
import OnboardingStepNextSteps from "./OnboardingStepNextSteps.vue";
import OnboardingStepBasicProfileInfo from "./OnboardingStepBasicProfileInfo.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Onboarding',
  setup(__props) {

// @ts-ignore
const steps = ref([
    {step: 1, name: "Welcome"},
    {step: 2, name: "Region"},
    {step: 3, name: "Goals"}, 
    {step: 4, name: "Headshot"},
    {step: 5, name: "Upgrade to PRO"},
    {step: 6, name: "Next steps"}
]);

const currentStep = ref(1);

const back = async () => {
    currentStep.value--;
};

const next = async () => {
    currentStep.value++;

    if (currentStep.value > steps.value.length) {
        window.location.href = "/membership/";
    } else {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"p-4 bg-white sm:p-8 sm:border-b-0 border-b-1 sm:border-transparent border-clay-300\"><div class=\"mx-auto max-100\"><div class=\"md:flex md:items-center md:justify-between\"><div class=\"flex-1 min-w-0\"><a href=\"/\"><img alt=\"\" class=\"w-auto h-8 mx-auto sm:mx-2 sm:blsock img-fluid\" src=\"/public/assets/img/logo.png\"></a></div><div class=\"mt-2 text-center sm:flex md:ml-4 md:mt-0\"><h2 class=\"italic leading-7 text-clay-900 text-md sm:truncate sm:text-xl sm:tracking-tight\">The leading resource for theatre artists</h2></div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("ol", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (s) => {
            return (_openBlock(), _createElementBlock("li", _hoisted_4, [
              (s.step < currentStep.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    title: s.name,
                    "aria-current": "step",
                    class: "flex items-center px-6 py-4 text-sm font-medium cursor-pointer",
                    onClick: ($event: any) => (currentStep.value = s.step)
                  }, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex items-center justify-center w-10 h-10 rounded-full shrink-0 bg-electric-600 group-hover:bg-electric-800" }, [
                      _createElementVNode("svg", {
                        "aria-hidden": "true",
                        class: "w-6 h-6 text-white",
                        fill: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          "clip-rule": "evenodd",
                          d: "M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z",
                          "fill-rule": "evenodd"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(s.name), 1)
                  ], 8, _hoisted_5))
                : _createCommentVNode("", true),
              (s.step === currentStep.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    title: s.name,
                    "aria-current": "step",
                    class: "flex items-center px-6 py-4 text-sm font-medium"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(s.step), 1)
                    ]),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(s.name), 1)
                  ], 8, _hoisted_7))
                : _createCommentVNode("", true),
              (s.step > currentStep.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    title: s.name,
                    "aria-current": "step",
                    class: "flex items-center px-6 py-4 text-sm font-medium"
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(s.step), 1)
                    ]),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(s.name), 1)
                  ], 8, _hoisted_11))
                : _createCommentVNode("", true),
              _cache[1] || (_cache[1] = _createElementVNode("div", {
                "aria-hidden": "true",
                class: "absolute top-0 right-0 hidden w-5 h-full md:block"
              }, [
                _createElementVNode("svg", {
                  class: "w-full h-full text-clay-300",
                  fill: "none",
                  preserveAspectRatio: "none",
                  viewBox: "0 0 22 80"
                }, [
                  _createElementVNode("path", {
                    d: "M0 -2L20 40L0 82",
                    stroke: "currentcolor",
                    "stroke-linejoin": "round",
                    "vector-effect": "non-scaling-stroke"
                  })
                ])
              ], -1))
            ]))
          }), 256))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (currentStep.value === 1)
            ? (_openBlock(), _createBlock(OnboardingStepBasicProfileInfo, {
                key: "1",
                onOnNext: next
              }))
            : _createCommentVNode("", true),
          (currentStep.value === 2)
            ? (_openBlock(), _createBlock(OnboardingStepRegion, {
                key: "2",
                onOnBack: back,
                onOnNext: next
              }))
            : _createCommentVNode("", true),
          (currentStep.value === 3)
            ? (_openBlock(), _createBlock(OnboardingStepGoals, {
                key: "3",
                onOnBack: back,
                onOnNext: next
              }))
            : _createCommentVNode("", true),
          (currentStep.value === 4)
            ? (_openBlock(), _createBlock(OnboardingStepHeadshot, {
                key: "4",
                onOnBack: back,
                onOnNext: next
              }))
            : _createCommentVNode("", true),
          (currentStep.value === 5)
            ? (_openBlock(), _createBlock(OnboardingStepUpgradeToPro, {
                key: "5",
                onOnBack: back,
                onOnNext: next
              }))
            : _createCommentVNode("", true),
          (currentStep.value === 6)
            ? (_openBlock(), _createBlock(OnboardingStepNextSteps, {
                key: "6",
                onOnBack: back
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})